import React from 'react';

export default function PlacePresentationEditor({ place, updateField }) {
  const signs = Array.isArray(place.signs) ? place.signs : [];
  const updateSign = (index, key, value) => updateField('signs', signs.map((sign, i) => i === index ? { ...sign, [key]: value } : sign));
  const addSign = () => updateField('signs', [...signs, {
    x: Number(place.location?.x) || 0,
    z: Number(place.shape?.minZ ?? place.location?.z) || 0,
    kind: 'sign', text: '', symbol: '', revealedName: '', targetPlaceId: '', facing: 'north',
    condition: 'intact', readableDistanceFeet: 35, illuminated: false, inside: false,
  }]);
  return (
    <fieldset className="place-presentation-editor">
      <legend>Appearance and signs</legend>
      {place.signageAvailable === false && <p>Sign metadata requires the add-place-presentation.sql migration before saving.</p>}
      <label className="editor-field">Unnamed place label
        <input value={place.publicLabel || ''} onChange={event => updateField('publicLabel', event.target.value)} placeholder="a timber-built inn" />
      </label>
      <label className="editor-field">Visible description before the name is known
        <textarea value={place.publicDescription || ''} onChange={event => updateField('publicDescription', event.target.value)} />
      </label>
      <p>Use visible features without hidden names or history. Signs teach names through readable lettering. A symbol alone does not reveal a name.</p>
      {signs.map((sign, index) => (
        <fieldset key={index}>
          <legend>Sign {index + 1}</legend>
          <label className="editor-field">Readable surface
            <select value={sign.kind || 'sign'} onChange={event => updateSign(index, 'kind', event.target.value)}>
              {['sign', 'map', 'inscription'].map(value => <option key={value}>{value}</option>)}
            </select>
          </label>
          {[
            ['text', 'Lettering'], ['symbol', 'Pictured symbol'], ['revealedName', 'Name in lettering'],
            ['targetPlaceId', 'Target place UUID (blank for this place)'],
          ].map(([key, label]) => <label className="editor-field" key={key}>{label}
            <input value={sign[key] || ''} onChange={event => updateSign(index, key, event.target.value)} />
          </label>)}
          {[
            ['x', 'World X (feet)'], ['z', 'World Z (feet)'], ['readableDistanceFeet', 'Reading distance (feet)'],
          ].map(([key, label]) => <label className="editor-field" key={key}>{label}
            <input type="number" step="any" value={sign[key] ?? ''} onChange={event => updateSign(index, key, event.target.value === '' ? '' : Number(event.target.value))} />
          </label>)}
          <label className="editor-field">Facing
            <select value={sign.facing || 'any'} onChange={event => updateSign(index, 'facing', event.target.value)}>
              {['any', 'north', 'south', 'east', 'west'].map(value => <option key={value}>{value}</option>)}
            </select>
          </label>
          <label className="editor-field">Condition
            <select value={sign.condition || 'intact'} onChange={event => updateSign(index, 'condition', event.target.value)}>
              {['intact', 'obscured', 'damaged', 'missing'].map(value => <option key={value}>{value}</option>)}
            </select>
          </label>
          <label><input type="checkbox" checked={sign.illuminated === true} onChange={event => updateSign(index, 'illuminated', event.target.checked)} /> Illuminated at night</label>
          <label><input type="checkbox" checked={sign.inside === true} onChange={event => updateSign(index, 'inside', event.target.checked)} /> Inside this place</label>
          <button type="button" className="secondary-button" onClick={() => updateField('signs', signs.filter((_, i) => i !== index))}>Remove sign {index + 1}</button>
        </fieldset>
      ))}
      <button type="button" className="secondary-button" onClick={addSign}>Add sign</button>
    </fieldset>
  );
}
